var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { getChildByType, removeChildrenByType } from 'react-nanny';
import { get, isNotNullOrEmpty, removeKeys } from '@pcty/utils';
import Checkbox from './ListCheckbox';
import Core from './ListCore';
import Group from './ListGroup';
import GroupTemplate from './ListGroupTemplate';
import Item from './ListItem';
import ItemTemplate from './ListItemTemplate';
var List = function (_a) {
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, data = _a.data, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.expandedIds, expandedIds = _c === void 0 ? [] : _c, id = _a.id, primaryKey = _a.primaryKey, renderState = _a.renderState, _d = _a.selected, selected = _d === void 0 ? [] : _d, _e = _a.__TYPE, TYPE = _e === void 0 ? 'List' : _e, other = __rest(_a, ["automationId", "children", "className", "css", "data", "disabled", "expandedIds", "id", "primaryKey", "renderState", "selected", "__TYPE"]);
    var template = getChildByType(children, ['ListItemTemplate']);
    var items = [];
    if (isNotNullOrEmpty(template)) {
        items = createItems(template, data, id, primaryKey, renderState, disabled, selected);
    }
    else {
        template = getChildByType(children, ['ListGroupTemplate']);
        items = createGroups(template, data, id, primaryKey, renderState, disabled, selected, expandedIds);
    }
    return (React.createElement(Core, __assign({ automationId: automationId, className: className, css: css }, other), items));
};
var createItems = function (template, data, id, primaryKey, renderState, disabled, selected) {
    return data.map(function (x, index) {
        var _a;
        var children = template.props.render(x, renderState);
        var checkbox = getChildByType(children, ['ListCheckbox']);
        if (isNotNullOrEmpty(checkbox)) {
            children = removeChildrenByType(children, ['ListCheckbox']);
            checkbox = React.cloneElement(checkbox, { checked: selected.indexOf(x[primaryKey]) >= 0 });
        }
        else {
            checkbox = getChildByType(get(children, 'props.children', []), ['ListCheckbox']);
            if (isNotNullOrEmpty(checkbox)) {
                checkbox = React.cloneElement(checkbox, {
                    checked: selected.indexOf(x[primaryKey]) >= 0,
                });
                children = __spreadArray([checkbox], removeChildrenByType(children.props.children, ['ListCheckbox']), true);
            }
        }
        return (React.createElement(Item, __assign({}, removeKeys(template.props, ['render', '__TYPE']), { disabled: disabled || ((_a = template.props) === null || _a === void 0 ? void 0 : _a.disabled), key: "generated-item-".concat(id, "-").concat(index), onClick: template.props.onClick && !disabled ? function () { return template.props.onClick(x); } : undefined, renderActionArea: template.props.renderActionArea ? function () { return template.props.renderActionArea(x, renderState, disabled); } : undefined }), children));
    });
};
var createGroups = function (template, data, id, primaryKey, renderState, disabled, selected, expandedIds) {
    return data.map(function (x, index) {
        var itemTemplate = getChildByType(template.props.children, ['ListItemTemplate']);
        var children = isNotNullOrEmpty(itemTemplate)
            ? createItems(itemTemplate, x[template.props.itemsKey], id, primaryKey, renderState, disabled, selected)
            : template.props.children;
        return (React.createElement(Group, __assign({}, removeKeys(template.props, ['itemsKey', 'titleKey', '__TYPE']), { checkbox: template.props.checkbox, checked: selected.indexOf(x[primaryKey]) >= 0, collapsed: expandedIds.indexOf(x[primaryKey]) === -1, collapsible: template.props.collapsible, key: "generated-group-".concat(id, "-").concat(index), onCheck: template.props.onCheck ? function () { return template.props.onCheck(x); } : undefined, onClick: template.props.onClick ? function () { return template.props.onClick(x); } : undefined, title: x[template.props.titleKey] }), children));
    });
};
List.defaultProps = {
    __TYPE: 'List',
};
export default Object.assign(List, {
    Checkbox: Checkbox,
    Core: Core,
    Group: Group,
    GroupTemplate: GroupTemplate,
    Item: Item,
    ItemTemplate: ItemTemplate,
});
